const initialState = {
    user: null,
    availableRoles: [],
    selectedRole: null,
    accessToken: null,
    refreshToken: null,
    isAuthenticated: false,
    initialized: false,
    error: null,
}

export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                user: action.payload.user,
                availableRoles: action.payload.availableRoles || [],
                selectedRole: action.payload.selectedRole || null,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                isAuthenticated: true,
                initialized: true,
                error: null,
            }
        case 'LOGIN_FAILURE':
            return {
                ...state,
                user: null,
                availableRoles: [],
                selectedRole: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
                initialized: true,
                error: action.payload,
            }
        case 'AUTH_BOOTSTRAP_FAILURE':
            return {
                ...state,
                user: null,
                availableRoles: [],
                selectedRole: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
                initialized: true,
                error: null,
            }
        case 'LOGOUT':
            return {
                ...state,
                user: null,
                availableRoles: [],
                selectedRole: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
                initialized: true,
                error: null,
            }
        case 'UPDATE_USER':
            return {
                ...state,
                user: { ...state.user, ...action.payload },
            }
        case 'SET_AVAILABLE_ROLES':
            return {
                ...state,
                availableRoles: action.payload.availableRoles || [],
                selectedRole: action.payload.selectedRole || state.selectedRole,
            }
        default:
            return state
    }
}
